import React, { useEffect, useState } from "react";
import "./LayoutStyles.css";
import { supabase } from "../../services/db";
import { useAuth } from "../../hooks/useAuth";
import Modal from "../Modal/Modal";
import AddRecipe from "../../pages/CreateRecipe";
import { ExitIcon, ReaderIcon } from "@radix-ui/react-icons";
import { ThemedIconButton } from "../Button/Button";

const LayoutWithNavigation = ({ ChildPage }) => {
  const { signOut } = useAuth();
  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    getUserInfo();
  }, []);

  const getUserInfo = async () => {
    const {
      data: { user },
    } = await supabase().auth.getUser();
    setUserInfo(user);
  };

  return (
    <div className="layoutContainer">
      <div className="header whiteFont">
        <div className="ProfileSection">
          <h1>Recipeat</h1>
          <h2>{userInfo?.user_metadata.full_name}</h2>
        </div>
        <div className="alignCenter">
          <div className="alignCenter">
            <Modal
              title="Add Recipe"
              buttonContent={
                <>
                  <ReaderIcon /> Add Recipe
                </>
              }
              fullpage
              content={(handleClose) => <AddRecipe handleClose={handleClose} />}
            />
            <ThemedIconButton onClick={signOut} aria-label="Log out">
              <ExitIcon />
            </ThemedIconButton>
          </div>
        </div>
      </div>
      <div className="content">
        <ChildPage />
      </div>
      <div className="footer whiteFont">
        <h4>Footer</h4>
      </div>
    </div>
  );
};
export default LayoutWithNavigation;
